'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (str) {

  if (typeof str == 'string' && str.length < 2) {
    return str.length ? '0' + str : '00';
  }

  if (typeof str == 'number') {
    return str < 10 ? '0' + str : str + '';
  }

  return str;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-date-picker/lib/utils/leftPad.js
// module id = 227
// module chunks = 0